<template>
    <tr>
        <td>{{ rowNumber }}</td>
        <td>{{ values.name }}</td>
        <td>{{ values.unit }}</td>
        <td>{{ values.amount }}</td>
        <td>{{ price }}</td>
        <td>{{ netPrice }}</td>
        <td>{{ values.taxName }}</td>
		<td>{{ tax }}</td>
		<td>{{ grossPrice }}</td>
	</tr>
</template>

<script>
    import {mapGetters} from 'vuex';
    export default {
        props: {
            values: {
                required: true
            },
            index: {
                type: Number,
                required: true
            },
        },
        computed: {
            price: function () {
                console.log(this.values);
                return parseFloat(this.values.price).toFixed(2)
            },
            tax: function () {
                return parseFloat(parseFloat(this.values.amount) * parseFloat(this.values.price) * (parseFloat(this.values.tax)/100)).toFixed(2)
            },
            netPrice: function () {
                return parseFloat(parseFloat(this.values.amount) * parseFloat(this.values.price)).toFixed(2)
            },
            grossPrice: function () {
                return parseFloat(parseFloat(this.values.amount) * parseFloat(this.values.price) + parseFloat(this.tax)).toFixed(2)
            },
            rowNumber: function () {
                return this.index + 1
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InvoiceItem.vue?5ae22206